import { useActionsContext } from '../framework';
import { useModalManager } from '@cotera/client/app/components';
import { commandPaletteModalItem } from './command-palette';
import { useAnalytics } from '@cotera/client/app/etc';

export const useOpenCommandPalette = () => {
  const isOpen = useModalManager((s) => s.open);
  const manager = useModalManager((s) => s.actions);
  const context = useActionsContext();
  const analytics = useAnalytics();

  return () => {
    if (isOpen) {
      return;
    }

    analytics.track('Command Palette Opened', { trigger: 'programmatic' });
    manager.push(commandPaletteModalItem({ context, analytics }));
  };
};
